import IRoute from './IRoute';
import Router from './Router';

export { IRoute, Router };



// WEBPACK FOOTER //
// ./src/routing/index.ts